import {Route, Routes, Outlet} from 'react-router-dom'
import {DynamicLog} from './components/DynamicLog'
import { DynamicMap } from './components/DynamicMap'

interface IDynamicParams {
  isDisplayed?: boolean
  maps?: any[]
}

export const TabMap = ({isDisplayed, maps}: IDynamicParams) => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/:accesscode'
          element={
            <>
              <DynamicMap isDisplayed={isDisplayed} maps={maps} />
            </>
          }
        />
      </Route>
      <Route element={<Outlet />}>
        <Route
          path='/:accesscode/:sysparam'
          element={
            <>
              <DynamicMap isDisplayed={isDisplayed} maps={maps} />
            </>
          }
        />
      </Route>
    </Routes>
  )
}
